import { DefaultValidator } from '..'
import { translateValidator } from '../../i18next/i18nextHelpers'
import { withDefaultValidator } from '../formValidators.utils'
import dayjs from 'dayjs'

const dateAboveTodayTranslateKey = 'validator.dateAboveToday'

export const dateAboveToday = (day: Date | string) => {
  return (
    dayjs().isBefore(dayjs(day), 'date') || dayjs().isSame(dayjs(day), 'date')
  )
}

export const dateAboveTodayTranslated: DefaultValidator = withDefaultValidator(
  (localeKey?: string) =>
    translateValidator(dateAboveToday, localeKey || dateAboveTodayTranslateKey),
)
